'use strict';

var BaseModel = require('./Base');
var log       = require('lib/log')('furnishing-model');
var Model;

module.exports = Model = BaseModel.extend('Furnishing', {
    softDelete: false,

    defaults: {
        furniture: false,
        airConditioners: false,
        carpets: false,
        curtains: false
    },

    constraints: {},

    save: function() {
        log.warn('Furnishing model is not meant to be persisted');
    },

    toJSON: function(options) {
        var self = this;
        var r = BaseModel.prototype.toJSON.apply(self, arguments);

        options = _.defaults(options || {}, {
            asAdditionalInformation: false
        });

        if (options.asAdditionalInformation === true) {
            _.each(_.keys(r), function(attr) {
                if (r[attr] === false) {
                    delete r[attr];
                    return;
                }

                switch (attr) {
                    case 'furniture':
                        r[attr] = 'Furniture';
                        break;
                    case 'airConditioners':
                        r[attr] = 'Air Conditioners';
                        break;
                    case 'carpets':
                        r[attr] = 'Carpets';
                        break;
                    case 'curtains':
                        r[attr] = 'Curtains';
                        break;
                }
            });
        }

        return r;
    }
}, {});



// WEBPACK FOOTER //
// ./app/models/Furnishing.js